<template>
  <div v-if="profile_loaded" class="profile-page">
    <PageHeader title="Configuración de Perfil" />

    <div class="profile-content">
      <!-- Personal Data Section -->
      <div class="profile-section card">
        <h4 class="section-title">Datos personales</h4>
        <div class="form-grid">
          <div class="form-group">
            <label for="nick">Nick</label>
            <input id="nick" placeholder="No hay información" v-model="user_data_values.input_nick"
              class="form-input form-input--disabled" type="text" disabled>
          </div>
          <div class="form-group">
            <label for="name">Nombre y apellidos</label>
            <input id="name" placeholder="No hay información" v-model="user_data_values.input_name"
              class="form-input form-input--disabled" type="text" disabled>
          </div>
          <div class="form-group">
            <label for="email">Correo electrónico</label>
            <input id="email" placeholder="No hay información" v-model="user_data_values.input_email"
              class="form-input form-input--disabled" type="text" disabled>
          </div>
          <div class="form-group">
            <label for="phone">Teléfono</label>
            <input id="phone" placeholder="No hay información" v-model="user_data_values.input_num_phone"
              class="form-input form-input--disabled" type="text" disabled>
          </div>
          <div class="form-group">
            <label for="gender">Género</label>
            <select id="gender" v-model="user_data_values.genre_select_class" class="form-select form-input--disabled" disabled>
              <option disabled selected value="">Elige un valor</option>
              <option v-for="gender in Object.keys(select_options.gender_options)" :value="gender" :key="'G' + gender">
                {{ select_options.gender_options[gender] }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="birthdate">Fecha de nacimiento (AAAA-MM-DD)</label>
            <input id="birthdate" placeholder="No hay información" v-model="user_data_values.input_date"
              class="form-input" type="text" @input="formatDate" @keydown="restrictInput">
          </div>
          <div class="form-group">
            <label for="category">Categoría profesional</label>
            <input id="category" placeholder="No hay información" v-model="user_data_values.input_category"
              class="form-input" type="text">
          </div>
          <div class="form-group">
            <label for="job">Trabajo</label>
            <input id="job" placeholder="No hay información" v-model="user_data_values.input_job" class="form-input"
              type="text">
          </div>
        </div>
      </div>

      <!-- How did you know us Section -->
      <div class="profile-section card">
        <h4 class="section-title">¿Cómo nos has conocido?</h4>
        <div class="form-group">
          <select v-model="user_data_values.know_us" class="form-select">
            <option disabled selected value="">Elige un valor</option>
            <option v-for="how in Object.keys(select_options.howknow_options)" :value="how" :key="'C' + how">{{
              select_options.howknow_options[how] }}</option>
          </select>
        </div>
      </div>

      <!-- Address Section -->
      <div class="profile-section card">
        <h4 class="section-title">Dirección</h4>
        <div class="form-grid">
          <div class="form-group">
            <label for="country">País</label>
            <select id="country" v-model="user_data_values.countries" class="form-select">
              <option disabled selected value="">Elige un valor</option>
              <option v-for="country in Object.keys(select_options.country_options)" :value="country" :key="'C' + country">
                {{ select_options.country_options[country] }}
              </option>
            </select>
          </div>
          <div v-if="user_data_values.countries == 68" class="form-group">
            <label for="state">Provincia</label>
            <select id="state" v-model="user_data_values.states" class="form-select">
              <option disabled selected value="">Elige un valor</option>
              <option v-for="city in Object.keys(select_options.city_options)" :value="city" :key="'C' + city">
                {{ select_options.city_options[city] }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="town">Localidad</label>
            <input id="town" placeholder="No hay información" v-model="user_data_values.input_town" class="form-input"
              type="text">
          </div>
          <div class="form-group">
            <label for="address">Dirección</label>
            <input id="address" placeholder="No hay información" v-model="user_data_values.input_address"
              class="form-input" type="text">
          </div>
          <div class="form-group">
            <label for="postcode">Código postal</label>
            <input id="postcode" placeholder="No hay información" v-model="user_data_values.input_postcode"
              class="form-input" type="text">
          </div>
        </div>
      </div>

      <!-- Billing Address Section -->
      <div class="profile-section card">
        <h4 class="section-title">Dirección de facturación</h4>
        <div class="form-grid">
          <div class="form-group">
            <label for="country_bill">País</label>
            <select id="country_bill" v-model="user_data_values.countries_bill" class="form-select">
              <option disabled selected value="">Elige un valor</option>
              <option v-for="country in Object.keys(select_options.country_options)" :value="country" :key="'C' + country">
                {{ select_options.country_options[country] }}
              </option>
            </select>
          </div>
          <div v-if="user_data_values.countries_bill == 68" class="form-group">
            <label for="state_bill">Provincia</label>
            <select id="state_bill" v-model="user_data_values.states_bill" class="form-select">
              <option disabled selected value="">Elige un valor</option>
              <option v-for="city in Object.keys(select_options.city_options)" :value="city" :key="'C' + city">
                {{ select_options.city_options[city] }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="town_bill">Localidad</label>
            <input id="town_bill" placeholder="No hay información" v-model="user_data_values.input_town_bill"
              class="form-input" type="text">
          </div>
          <div class="form-group">
            <label for="address_bill">Dirección</label>
            <input id="address_bill" placeholder="No hay información" v-model="user_data_values.input_address_bill"
              class="form-input" type="text">
          </div>
          <div class="form-group">
            <label for="postcode_bill">Código postal</label>
            <input id="postcode_bill" placeholder="No hay información" v-model="user_data_values.input_postcode_bill"
              class="form-input" type="text">
          </div>
        </div>
      </div>

      <!-- Fiscal Data Section -->
      <div class="profile-section card">
        <h4 class="section-title">Datos fiscales</h4>
        <div class="form-grid">
          <div class="form-group">
            <label for="nif">NIF</label>
            <input id="nif" placeholder="No hay información" v-model="user_data_values.input_num_fiscal"
              class="form-input form-input--disabled" type="text" disabled>
          </div>
          <div class="form-group">
            <label for="fiscal_name">Nombre y apellidos</label>
            <input id="fiscal_name" placeholder="No hay información" v-model="user_data_values.input_name_fiscal"
              class="form-input form-input--disabled" type="text" disabled>
          </div>
        </div>
      </div>

      <!-- Communication Section -->
      <div class="profile-section card">
        <h4 class="section-title">Comunicación</h4>
        <div class="checkbox-group">
          <div class="checkbox-item">
            <input id="email_comms" v-model="user_data_values.key_email" type="checkbox" class="form-checkbox">
            <label for="email_comms">Acepto correos</label>
          </div>
          <div class="checkbox-item">
            <input id="newsletter" v-model="user_data_values.key_newletter" type="checkbox" class="form-checkbox">
            <label for="newsletter">Quiero recibir la Newsletter semanal</label>
          </div>
          <div class="checkbox-item">
            <input id="sms_comms" v-model="user_data_values.key_sms" type="checkbox" class="form-checkbox">
            <label for="sms_comms">Acepto SMS</label>
          </div>
        </div>
      </div>
      
      <!-- Actions Section -->
      <div class="profile-actions card">
         <h4 class="section-title">Acciones</h4>
        <button @click="saveProfileInfo" class="btn btn--primary">GUARDAR CAMBIOS</button>
        <button @click="discardChanges" class="btn btn--secondary">DESCARTAR CAMBIOS</button>
      </div>

       <!-- Password Section -->
      <div class="profile-section card">
        <h4 class="section-title">Contraseña</h4>
        <button @click="goToChangePassword" class="btn btn--secondary">CAMBIAR CONTRASEÑA</button>
      </div>

    </div>
  </div>
  <div id="profile-fail-load" v-else>
    <div class="fail-load-content">
      <h1>Hay problemas recuperando el perfil.</h1>
      <p>Por favor, inténtelo de nuevo más tarde o póngase en contacto con nosotros.</p>
      <button @click="discardChanges" class="btn btn--primary">Intentar de nuevo</button>
      <button @click="goToStockchart" class="btn btn--secondary">Volver al Graficador Dinámico</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import APICaller from "@/shared/mixins/APICaller.js";
import PageHeader from "@/shared/components/common/PageHeader.vue";

export default {
  mixins: [APICaller],
  name: 'MyProfile',
  components: {
    PageHeader
  },
  data() {
    return {
      user_data_values: {
        input_nick: '',
        input_name: '',
        input_email: '',
        input_num_phone: '',
        genre_select_class: '',
        input_category: '',
        input_job: '',
        countries: '',
        states: '',
        input_town: '',
        input_address: '',
        input_postcode: '',
        know_us: '',
        input_num_fiscal: '',
        input_name_fiscal: '',
        countries_bill: '',
        states_bill: '',
        input_town_bill: '',
        input_address_bill: '',
        input_postcode_bill: '',
        input_date: '',
        key_newletter: false,
        key_email: false,
        key_sms: false,
      },
      select_options: {
        gender_options: {},
        country_options: {},
        city_options: {},
        howknow_options: {}
      },
      profile_loaded: true
    };
  },
  computed: {
    ...mapGetters(["_g_UserId"])
  },
  created() {
    this.loadProfileInfo();
  },
  mounted() {

  },
  methods: {
    loadProfileInfo: function () {
      let success = (response) => {
        if(response.data.profile_info) {
          this.select_options.gender_options = response.data.genero_options;
          this.select_options.country_options = response.data.pais_options;
          this.select_options.city_options = response.data.provincia_options;
          this.select_options.howknow_options = response.data.conocido_options;

          this.user_data_values.input_nick = response.data.profile_info.nick;
          this.user_data_values.input_name = response.data.profile_info.name;
          this.user_data_values.input_email = response.data.profile_info.email;
          this.user_data_values.input_num_phone = response.data.profile_info.mobile;
          this.user_data_values.genre_select_class = response.data.profile_info.sexo;
          this.user_data_values.input_category = response.data.profile_info.categoria;
          this.user_data_values.input_job = response.data.profile_info.profesion;
          this.user_data_values.countries = response.data.profile_info.country_id[0] && response.data.profile_info.country_id[0] !== "" ? response.data.profile_info.country_id[0] : 68;
          this.user_data_values.states = response.data.profile_info.state_id[0] && response.data.profile_info.state_id[0] !== "" ? response.data.profile_info.state_id[0] : 417;
          this.user_data_values.input_town = response.data.profile_info.city;
          this.user_data_values.input_address = response.data.profile_info.street;
          this.user_data_values.input_postcode = response.data.profile_info.zip;
          this.user_data_values.know_us = response.data.profile_info.how_know;
          this.user_data_values.input_num_fiscal = response.data.profile_info.cif;
          this.user_data_values.input_name_fiscal = response.data.profile_info.fiscal_name;
          this.user_data_values.countries_bill = response.data.profile_info.fiscal_country_id[0] && response.data.profile_info.fiscal_country_id[0] !== "" ? response.data.profile_info.fiscal_country_id[0] : 68;
          this.user_data_values.states_bill = response.data.profile_info.fiscal_state_id[0] && response.data.profile_info.fiscal_state_id[0] !== "" ? response.data.profile_info.fiscal_state_id[0] : 417;
          this.user_data_values.input_town_bill = response.data.profile_info.fiscal_city;
          this.user_data_values.input_address_bill = response.data.profile_info.fiscal_street;
          this.user_data_values.input_postcode_bill = response.data.profile_info.fiscal_postal_code;
          this.user_data_values.input_date = response.data.profile_info.fecha_nacimiento;
          this.user_data_values.key_newletter = response.data.profile_info.si_newsletters;
          this.user_data_values.key_email = response.data.profile_info.si_messages;
          this.user_data_values.key_sms = response.data.profile_info.si_sms_messages;
        }
        else {
          this.profile_loaded = false;
        }
      };

      let failure = () => {
        this.profile_loaded = false;
      }

      let url = '/api/v1/profile-info'

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('350', 'Error recuperando información de usuario.', failure);

      this._getAPICall(url, successHandler, failureHandler);
    },

    saveProfileInfo: function () {
      let url = '/api/v1/write-profile-info';
      const successHandler = new APICaller.SuccessHandler(this.discardChanges);
      const failureHandler = new APICaller.FailureHandler('351', 'Error escribiendo la información de usuario');
      const params = new URLSearchParams;
      params.append("input_nick", this.user_data_values.input_nick);
      params.append("input_name", this.user_data_values.input_name);
      params.append("input_email", this.user_data_values.input_email);
      params.append("input_num_phone", this.user_data_values.input_num_phone);
      params.append("genre_select_class", this.user_data_values.genre_select_class);
      params.append("input_category", this.user_data_values.input_category);
      params.append("input_job", this.user_data_values.input_job);
      params.append("countries", this.user_data_values.countries);
      params.append("states", this.user_data_values.states);
      params.append("input_town", this.user_data_values.input_town);
      params.append("input_address", this.user_data_values.input_address);
      params.append("input_postcode", this.user_data_values.input_postcode);
      params.append("know_us", this.user_data_values.know_us);
      params.append("input_num_fiscal", this.user_data_values.input_num_fiscal);
      params.append("input_name_fiscal", this.user_data_values.input_name_fiscal);
      params.append("countries_bill", this.user_data_values.countries_bill);
      params.append("states_bill", this.user_data_values.states_bill);
      params.append("input_town_bill", this.user_data_values.input_town_bill);
      params.append("input_address_bill", this.user_data_values.input_address_bill);
      params.append("input_postcode_bill", this.user_data_values.input_postcode_bill);
      params.append("input_date", this.user_data_values.input_date);
      params.append("key_newletter", this.user_data_values.key_newletter);
      params.append("key_email", this.user_data_values.key_email);
      params.append("key_sms", this.user_data_values.key_sms);

      this._postAPICall(url, params, successHandler, failureHandler);
    },

    discardChanges: function () {
      location.reload();
    },

    restrictInput(event) {
      // Get the current input value and key code of the pressed key
      const inputValue = event.target.value;
      const keyCode = event.keyCode || event.which;

      // Allow only digits and dashes
      if (keyCode !== 45 && (keyCode < 48 || keyCode > 57) && keyCode !== 8) {
        event.preventDefault();
      }

      // Restrict the input to the format of YYYY-MM-DD
      if ((inputValue.length === 4 || inputValue.length === 7) && keyCode !== 8) {
        event.target.value += '-';
      }
    },
    formatDate() {
      // Get the current input value
      const inputValue = this.user_data_values.input_date;

      // Restrict the input to the format of YYYY-MM-DD
      if (inputValue.length > 10) {
        this.user_data_values.input_date = inputValue.substring(0, 10);
      }
    },
    goToChangePassword() {
      this.$router.push("change-password");
    },
    goToStockchart() {
      this.$router.push('graficador-dinamico');
    }
  }
}
</script>




<style lang="scss" scoped>
.profile-page {
  background-color: var(--color-background, #f8f9fa);
  color: var(--color-text-primary, #212529);
  padding: 20px 5%;
  min-height: 100vh;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;
}

.profile-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.card {
  background-color: var(--color-surface, #ffffff);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  padding: 25px 30px;
  border: 1px solid var(--color-outline, #ced4da);
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-top: 0;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline, #e0e0e0);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--color-text-secondary, #6c757d);
  }
}

.form-input,
.form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--color-outline, #ced4da);
  border-radius: 6px;
  background-color: var(--color-input-background, #fff);
  color: var(--color-text-primary);
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--color-highlight, #007bff);
    box-shadow: 0 0 0 3px var(--color-primary-alpha, rgba(0, 123, 255, 0.25));
  }

  &::placeholder {
    color: var(--color-text-placeholder, #6c757d);
    opacity: 0.7;
  }
}

.form-input--disabled,
.form-select--disabled {
  background-color: var(--color-muted, #f0f0f0);
  color: var(--color-text-secondary);
  cursor: not-allowed;
  border-color: var(--color-outline);

  &:hover, &:focus {
    border-color: var(--color-outline);
    box-shadow: none;
  }
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    font-size: 0.9rem;
    color: var(--color-text-primary);
    cursor: pointer;
  }

  &--terms {
    align-items: flex-start;
    .form-helper-text { margin-top: 2px; }
  }
}

.form-checkbox {
  width: 20px;
  height: 20px;
  accent-color: var(--color-highlight, #007bff);
  cursor: pointer;
}

.form-helper-text {
  font-size: 0.8rem;
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.link {
  color: var(--color-highlight, #007bff);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.profile-actions {
  display: flex;
  flex-direction: column;

  .btn {
    width: 100%;
  }

  @media (min-width: 600px) {
    flex-direction: column;
    justify-content: flex-start;
    .btn {
      width: auto;
      flex-grow: 1;
      max-width: 250px;
    }
  }
}

.profile-section.card .btn {
  width: 100%;
  @media (min-width: 600px) {
    max-width: 300px;
  }
}

.btn {
  padding: 12px 25px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  border: 1px solid transparent;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &--primary {
    background-color: var(--color-highlight, #007bff);
    color: var(--color-text-on-highlight, #fff);
    border-color: var(--color-highlight, #007bff);
    margin-bottom: 15px;

    &:hover {
      background-color: #007bff;
      border-color: #007bff;
      filter: brightness(90%);
    }
  }

  &--secondary {
    background-color: var(--color-surface, #fff);
    color: var(--color-highlight, #007bff);
    border-color: var(--color-highlight, #007bff);

    &:hover {
      background-color: var(--color-primary-alpha, rgba(0, 123, 255, 0.1));
    }
  }
}

#profile-fail-load {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  text-align: center;
  padding: 20px;

  .fail-load-content {
    background-color: var(--color-surface, #fff);
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 100%;

    h1 {
      font-size: 1.5rem;
      color: var(--color-error, #dc3545);
      margin-bottom: 15px;
    }

    p {
      font-size: 1rem;
      color: var(--color-text-secondary);
      margin-bottom: 30px;
    }

    .btn {
      margin-top: 10px;
      width: 100%;
      &:first-of-type {
        margin-right: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  .profile-page {
    padding: 20px 15px;
  }
  .card {
    padding: 20px;
  }
  .section-title {
    font-size: 1.1rem;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .btn {
    padding: 10px 15px;
    font-size: 0.85rem;
  }
  #profile-fail-load .fail-load-content {
    padding: 25px;
    h1 { font-size: 1.3rem; }
    p { font-size: 0.9rem; }
  }
}
</style>
